import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BoxPopularSearches from 'src/components/BoxPopularSearches';
import Pagination from 'src/components/Pagination/PaginationWrapper';
import SectionContainer from 'src/containers/SectionContainer';


const PopularSearchesContainer = ({ tiles }) => (
  <SectionContainer dataTestName="section-seo-searches" title="Najczęściej szukane">
    <Pagination>
      {tiles.map(({ name, url }) => {
        const key = `popular-search-${name}`;

        return (
          <BoxPopularSearches
            key={ key }
            link={ url }
            title={ name }
          />
        );
      })}
    </Pagination>
  </SectionContainer>
);

PopularSearchesContainer.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.object).isRequired
};

const mapStateToProperties = ({ seoReducer }) => ({
  tiles: seoReducer.searches
});

export default connect(mapStateToProperties)(PopularSearchesContainer);
